import { i18n } from "@/main";
import { CvRow } from "@/types";

function getTechBuzzwords(): string[] {
  return [
    "Node.js",
    "Spring Boot",
    "nestjs",
    "Java EE",
    "Java",
    "Angular",
    "Vue",
    "Alexa Skills",
    "Google Conversational Actions",
    "Ionic",
    "TypeScript",
    "JavaScript",
    "RESTful APIs",
    "gRPC",
    "Material Design",
    "Responsive Apps",
    "Docker",
    "git",
    "GitHub Actions",
    "Tomcat",
    "MySQL",
    "PostgreSQL",
    "Scrum",
    "Agile Software Development",
    "Web Apps",
    "Hybrid Apps",
    "Kanban",
    "...",
  ];
}

function getCvData(): CvRow[] {
  return [
    {
      name: "freelance",
      timeperiod: `2017 - ${i18n?.t("cv.today")}`,
      mainText: i18n?.t("cv.freelance.title").toString(),
      additionalText: i18n.t("cv.freelance.additional").toString(),
    },
    {
      name: "conetWork",
      timeperiod: `2017 - 2018`,
      mainText: `${i18n?.t(
        "cv.conet.title"
      )}<a class="blacklink" href="https://www.conet.de/DE/conet" target="_blank">${i18n.t(
        "cv.conet.link"
      )}</a>`,
      additionalText: i18n?.t("cv.conet.additional").toString(),
    },
    {
      name: "workingStudent",
      timeperiod: `2014 - 2017`,
      mainText: `${i18n?.t(
        "cv.workingstudent.title"
      )}<a class="blacklink" href="https://www.conet.de/DE/conet" target="_blank">${i18n.t(
        "cv.workingstudent.link"
      )}</a>`,
      additionalText: i18n?.t("cv.workingstudent.additional").toString(),
    },
    {
      name: "student",
      timeperiod: `2013 - 2016`,
      mainText: `${i18n?.t(
        "cv.student.title"
      )}<a class="blacklink" href="https://www.h-brs.de/de" target="_blank">${i18n.t(
        "cv.student.link"
      )}</a>`,
      additionalText: i18n?.t("cv.student.additional").toString(),
    },
    {
      name: "hiwi",
      timeperiod: `2015 - 2016`,
      mainText: `${i18n?.t(
        "cv.hiwi.title1"
      )}<a class="blacklink" href="https://www.h-brs.de/de" target="_blank">${i18n.t(
        "cv.hiwi.link"
      )}</a>${i18n.t("cv.hiwi.title2")}`,
      additionalText: i18n?.t("cv.hiwi.additional").toString(),
    },
    {
      name: "scholarship",
      timeperiod: `2014 - 2014`,
      mainText: `${i18n?.t(
        "cv.scholarship.title"
      )}<a class="blacklink" href="https://www.deutschlandstipendium.de/index.html" target="_blank">${i18n.t(
        "cv.scholarship.link"
      )}</a>`,
      additionalText: `${i18n?.t(
        "cv.scholarship.additional"
      )}<a class="blacklink" href="https://www.ser.de/" target="_blank">${i18n.t(
        "cv.scholarship.additionalLink"
      )}</a>`,
    },
    {
      name: "tutor",
      timeperiod: `2014 - 2014`,
      mainText: `${i18n?.t(
        "cv.tutor.title1"
      )}<a class="blacklink" href="https://www.h-brs.de/de" target="_blank">${i18n.t(
        "cv.tutor.link"
      )}</a>${i18n.t("cv.tutor.title2")}`,
      additionalText: i18n?.t("cv.tutor.additional").toString(),
    },
    {
      name: "shd",
      timeperiod: `2013 - 2013`,
      mainText: `${i18n?.t(
        "cv.shd.title"
      )}<a class="blacklink" href="https://www.shd.de/" target="_blank">${i18n.t(
        "cv.shd.link"
      )}</a>`,
      additionalText: i18n?.t("cv.shd.additional").toString(),
    },
    {
      name: "shdA",
      timeperiod: `2010 - 2013`,
      mainText: `${i18n?.t(
        "cv.shdA.title"
      )}<a class="blacklink" href="https://www.shd.de/" target="_blank">${i18n.t(
        "cv.shdA.link"
      )}</a>`,
      additionalText: i18n?.t("cv.shdA.additional").toString(),
    },
  ];
}

export { getTechBuzzwords, getCvData };
